import React from 'react'
import { Link } from 'react-router-dom'
import Button from '../../../components/Button/Button'
import Skeleton from 'react-loading-skeleton'

const Profiledetails = ({ isActiveTab, setIsActive, data, isFetching }) => {
    return (
        <div className={`ContainerTabForAllTabData tabWrapper ${isActiveTab && 'active'}`}>
            <div className="Headingforallheader slotdetailsfixpd">
                <div className="flex-between w-100">
                    <h2 className="heading-2">Profile Details</h2>
                    <Button name={'Edit Profile'} src={'/assets/icons/AddIcon.svg'} className="BlueFillButton btnpadding" onClick={() => setIsActive(2)} />
                </div>
            </div>

            <div className="border-btm w-100"></div>

            <div className="bodyDataForallUserdata Adfixwidthalldata">
                <div className="profileDetailsWrap">
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : 'First Name'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : data?.firstName ? data?.firstName : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : 'Last Name'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : data?.lastName ? data?.lastName : "---"}
                        </div>
                    </div>

                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : 'Phone Number'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : data?.mobileNumber ? data?.mobileNumber : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : 'Email'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {isFetching ? <Skeleton width={"200px"} /> : data?.email ? data?.email : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"140px"} /> : 'Qualification Level'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : data?.profession?.title ? data?.profession?.title === "student" ? 'Student' : 'Working Professional' : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"130px"} /> : `${data?.profession?.title === "student" ? "Qualification" : "Professional"} Domain`}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : data?.profession?.company ? data?.profession?.company : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : `${data?.profession?.title === "student" ? 'Year of Study' : 'Working Experience'}`}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : data?.profession?.yrsOfExp ? data?.profession?.yrsOfExp: "---"}{!isFetching ? data?.profession?.title === "student" ? 'year' :'+ years' : ''}
                        </div>
                    </div>


                </div>

            </div>

        </div>
    )
}

export default Profiledetails
